import * as React from 'react';

import Link from 'components/Link';
import Row from 'components/Row';
import Text from 'components/Text';

import './styles/WizardHelperText.scss';

type Props = {
  text: string;
  linkLabel: string;
  onClickLink: () => void;
};

export default function WizardHelperText(props: Props) {
  const { text, linkLabel, onClickLink } = props;

  return (
    <div className="WizardHelperText">
      <Text align="left" size="xsmall">
        <Row size="xsmall">
          <Text color="thunder">{text}</Text>
        </Row>
        <Link onClick={onClickLink}>
          <Text weight="semibold">{linkLabel}</Text>
        </Link>
      </Text>
    </div>
  );
}
